import { createTheme, ThemeOptions } from "@mui/material/styles";

declare module '@mui/material/styles' {
  interface Palette {
    ai: Palette['primary'];
  }
  interface PaletteOptions {
    ai?: PaletteOptions['primary'];
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    ai: true;
  }
}

const lang = window.localStorage.getItem('lang') || 'zh-CN';

const theme = createTheme({
  palette: {
    primary: {
      main: "#b54825", // Warm reddish-brown (similar to MS PowerPoint)
      light: "#d16f4f", // Lighter shade of primary
      dark: "#8c3116", // Darker shade of primary
      50: "#faf6f5", // Very very light shade of primary
    },
    secondary: {
      main: "#607D8B",
      light: "#90A4AE",
      dark: "#455A64",
    },
    ai: {
      main: "#a02e95", // Deep purple
      light: "#b039aa", // Lighter purple
      dark: "#6d1a71", // Darker purple
      contrastText: "#FFFFFF", // White text for contrast
    },
    // secondary: {
    //   main: "#2d7d9a", // Teal blue (complementary to primary)
    //   light: "#4ba3c3", // Lighter shade of secondary
    //   dark: "#1c5b72", // Darker shade of secondary
    // },
    background: {
      default: "#f9f5f3", // Light warm beige
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: lang.includes('en') ? `
      "Helvetica Neue",
      "Noto Sans SC",
      "Roboto",
      "Helvetica",
      "Arial",
      "Microsoft YaHei UI",
      "Microsoft YaHei",
      "STHeiti",
      "Noto Sans TC",
      sans-serif
    ` : `
      "PingFang SC",
      "Microsoft YaHei UI",
      "Noto Sans SC",
      "Roboto",
      "Helvetica",
      "Arial",
      "Microsoft YaHei",
      "STHeiti"
    `,
    // h1: {
    //   fontSize: "2.5rem",
    //   fontWeight: 500,
    // },
    // h2: {
    //   fontSize: "2rem",
    //   fontWeight: 500,
    // },
    // h3: {
    //   fontSize: "1.75rem",
    //   fontWeight: 500,
    // },
    // h4: {
    //   fontSize: "1.5rem",
    //   fontWeight: 500,
    // },
    // h5: {
    //   fontSize: "1.25rem",
    //   fontWeight: 500,
    // },
    // h6: {
    //   fontSize: "1rem",
    //   fontWeight: 500,
    // },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "standard",
      },
    },
    MuiIconButton: {
      defaultProps: {
        size: "large",
      },
    },
    // MuiPaper: {
    //   styleOverrides: {
    //     root: {
    //       backgroundColor: "rgba(249, 245, 243, 0.95)", // Light warm beige with opacity
    //     },
    //   },
    // },
  },
} as ThemeOptions);

export default theme;